import { Footer, Work } from '../container';
import PageHero from "../components/PageHero/PageHero";
import aboutBg from "../assets/bgimage.jpg";
export default function ProjectsPage() {
  return <>
  <PageHero title="Projects" bgImage={aboutBg} />
  <Work/>
  <Footer/>
  </>;
}
